import React from "react";
import PropTypes from "prop-types";

import { STREAM_TYPE } from "config/constants";
import Stream from "stream/containers/Stream";
import StandardLayout from "components/Library/Layout/containers/StandardLayout";
import AuthorStreamHeader from "stream/components/AuthorStreamHeader";
import FullStoryCard from "cards/containers/FullStoryCard";
import AuthorStreamHelmet from "stream/components/AuthorStreamHelmet";

const AuthorStream = ({ match }) => (
  <>
    <AuthorStreamHelmet username={match.params.username} />
    <AuthorStreamHeader username={match.params.username} />
    <StandardLayout
      main={
        <Stream
          type={STREAM_TYPE.AUTHOR}
          lookup={match.params.username}
          onlyShowTitleForA11y={true}
          contentComponent={FullStoryCard}
          disableUrlUpdating={true}
        />
      }
      mainAriaLabel="Stories"
    />
  </>
);

AuthorStream.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      username: PropTypes.string.isRequired,
    }),
  }),
};

export default AuthorStream;
